import { VuexModule, Module, Mutation } from "vuex-module-decorators";
import PaginateModel from "@/model/paginate";
import OrderHistory from "@/model/orderHistory";

@Module({ namespaced: true })
export default class OrderModule extends VuexModule {
  history: OrderHistory[] = [];
  paginate: PaginateModel;
  @Mutation
  setOrderHistory(history: OrderHistory[]): void {
    this.history = history;
  }
  @Mutation
  setPaginate(paginate: PaginateModel): void {
    this.paginate = paginate;
  }

  // @Action
  // async fetchOrderHistory(query): Promise<void> {
  //   const { list, paginate } = await orderApi.getHistory(query);
  //   this.context.commit("setOrderHistory", list);
  //   this.context.commit("setPaginate", paginate);
  // }
  //
  // @Action
  // async fetchOrderHistoryByCustomer(query): Promise<void> {
  //   const { list, paginate } = await orderApi.getHistoryByCustomer(query);
  //   list.map(function (item) {
  //     item.order_items = _.groupBy(item.order_items, "okurijo_number");
  //     return item;
  //   });
  //   this.context.commit("setOrderHistory", list);
  //   this.context.commit("setPaginate", paginate);
  // }

  get getOrderHistory(): OrderHistory[] {
    return this.history;
  }
  get getPaginate(): PaginateModel {
    return this.paginate;
  }
}

// export default getModule(AuthModule);
